export const STRIPE_KEY = "pk_live_ChkaaQrnXtrykZrkvavUmknd00quTkajK9";